module.exports = __webpack_public_path__ + "img/f2.c7ef644e.png";